import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthUser } from "hooks/useAuthUser";

const PrivateRoutes = () => {
  const { user, isAuthenticated } = useAuthUser();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (user?.firstTimeLogin) {
    return <Navigate to="/sign-up" replace />;
  }

  return <Outlet />;
};

export default PrivateRoutes;
